import Accordion from 'LuxKit/Accordion'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import React from 'react'

export default function TravellerPaymentAndInvoicing() {
  return (
    <Group direction="vertical" gap={8}>
      <Heading variant="heading4">Payment and invoicing</Heading>
      <Accordion size="large" heading="Where can I find download an invoice for my booking">
        <BodyText variant="large">
          To find and download an invoice for your booking, please follow these steps:
        </BodyText>
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">View Your Account:</BodyText>
              <BodyText variant="large"> Navigate to the top right-hand side of the navigation bar and click on "Account"</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Select "My Bookings" from the Dropdown:</BodyText>
              <BodyText variant="large"> In the dropdown menu, locate and click on "My Bookings."</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Access Your Bookings:</BodyText>
              <BodyText variant="large"> You will be directed to a page displaying all your upcoming and past bookings. Each booking will be listed with relevant details.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Download Invoice:</BodyText>
              <BodyText variant="large"> Below the "View Booking" option for each booking tile, you'll find a "Download Invoice" button. Select on this button corresponding to the booking for which you require an invoice.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
      <Accordion size="large" heading="How can I pay for my trip?">
        <ol>
          <Group direction="vertical" gap={12}>
            <li>
              <BodyText variant="large" weight="bold">Company Card:</BodyText>
              <BodyText variant="large"> If you have access to your company card, you may use it to pay for your trip. This allows for direct payment from your company's funds, streamlining the payment process.</BodyText>
            </li>
            <li>
              <BodyText variant="large" weight="bold">Personal Card:</BodyText>
              <BodyText variant="large"> Alternatively, if you do not have access to a company card, you can use your personal credit or debit card to pay for your trip. In this case, you will be responsible for covering the expenses upfront. Depending on your company's reimbursement policies, you may then submit your expenses for reimbursement, and the company will reimburse you for the approved expenses.</BodyText>
            </li>
          </Group>
        </ol>
      </Accordion>
    </Group>
  )
}
